export default "__VITE_ASSET__DJ67jFJG__"